import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'
import ServerError from './common/500'
// import './stylus/main.styl'
import store from './store'

import RupeeLoader from './components/RupeeLoader.vue'
import PageBreadcrumb from './components/PageBreadcrumb.vue'

//date time picker
import DatetimePicker from 'vuetify-datetime-picker'
// import './components/stylus/main.styl'
Vue.use(DatetimePicker)


// import JsonExcel from "vue-json-excel";
// Vue.component("downloadExcel",JsonExcel);


Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.component('VueElementLoading', RupeeLoader)
Vue.component('RupeeLoader', RupeeLoader)
Vue.component('ServerError', ServerError)
Vue.component('PageBreadcrumb', PageBreadcrumb)

Vue.config.productionTip = false

if (!process.env.VUE_APP_API_BASE_URL) {
  throw new Error('VUE_APP_API_BASE_URL is not set. Add it to .env, .env.development, or .env.production.');
}

const apiBase = (process.env.VUE_APP_API_BASE_URL || '').trim();
axios.defaults.baseURL = apiBase;
Vue.prototype.baseURL = apiBase;
Vue.prototype.mediaURL = apiBase + '/file/get/';

// Global safety net, layered on top of (not replacing) each view's own
// .then()/.catch() handling:
//  - forces a logout when the backend flags the session as expired/invalid,
//    since nothing else in the app currently reacts to that signal at all
//  - surfaces transport-level failures (network errors, 5xx, rate limiting)
//    that today fail completely silently, since the backend returns HTTP 200
//    even for most business-logic errors and those are handled per-view already
axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.loggedout) {
      localStorage.clear();
      store.state.isLoggedIn = false;
      if (router.currentRoute.name !== 'login') {
        router.push({ name: 'login' });
      }
    }
    return response;
  },
  (error) => {
    if (!error.response) {
      store.commit('setGlobalErrorMessage', 'Network error. Please check your connection and try again.');
    } else if (error.response.status === 429) {
      store.commit('setGlobalErrorMessage', 'Too many requests. Please slow down and try again.');
    } else if (error.response.status >= 500) {
      store.commit('setGlobalErrorMessage', 'Something went wrong on the server. Please try again.');
    }
    return Promise.reject(error);
  }
);

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')